import { GetEvent, PatchEvent, SubmitEvent } from '~/machines/base-crud';
import { Attestation, AttestationForm } from '~/types';
import { deleteData, getData, patchData, postData } from '~/utils/service';
import { DeleteAttestation, PatchAttestation, SubmitAttestation } from './events';
import { Context } from './types';
import { formDataToAttestation } from './utils';

const ATTESTATIONS_ROUTE_NAME = 'attestations';
const ATTESTATION_FORM_ROUTE_NAME = 'attestation_forms';
const ATTESTATION_ROUTE_NAME = 'attestation';

const BASE_URL = 'attestations';
export const ATTESTATION_FORM_ROUTES = {
  get: `${BASE_URL}/form`,
};

export const ATTESTATIONS_ROUTES = {
  get: `/${BASE_URL}/{providerId}`,
};

export const ATTESTATION_ROUTE = {
  delete: `/${BASE_URL}/attestation/{id}`,
  get: `/${BASE_URL}/attestation/{id}`,
  patch: `${BASE_URL}/attestation`,
  post: `${BASE_URL}/attestation`,
};

interface Input<T> {
  input: {
    context: Context;
    event: T;
  };
}

export const FORM_API_CALLS = {
  get: async ({ input }: Input<GetEvent>): Promise<AttestationForm[]> => {
    return await getData(ATTESTATION_FORM_ROUTE_NAME, {
      pathParams: {
        providerId: input.context.providerId.toString(),
      },
    });
  },
};

export const ATTESTATIONS_API_CALLS = {
  get: async ({ input }: Input<GetEvent>): Promise<Attestation[]> => {
    return await getData(ATTESTATIONS_ROUTE_NAME, {
      pathParams: {
        providerId: input.context.providerId.toString(),
      },
    });
  },
};

export const ATTESTATION_API_CALLS = {
  get: async ({ input }: Input<GetEvent>): Promise<Attestation[]> => {
    return await getData(ATTESTATION_ROUTE_NAME, {
      pathParams: {
        providerId: input.context.providerId.toString(),
      },
    });
  },
  // Creates and locks Attestation
  create: async ({ input }: Input<SubmitEvent<unknown>>): Promise<AttestationForm> => {
    const event = input.event as SubmitAttestation;
    const data = formDataToAttestation(event.values, input.context);

    if (input.context.idToEdit) {
      const attestation = input.context.attestations.find(
        (attestation) => attestation.id == input.context.idToEdit
      );

      return await postData(ATTESTATION_ROUTE_NAME, {
        responseType: 'arraybuffer',
        data: {
          ...attestation,
          formInstance: {
            ...attestation?.formInstance,
            formData: data.formInstance.formData,
            updatedAt: new Date().toISOString(),
          },
        },
      });
    }

    return await postData(ATTESTATION_ROUTE_NAME, {
      responseType: 'arraybuffer',
      data,
    });
  },
  // Upserts and doesn't lock Attestation
  patch: async ({ input }: Input<PatchEvent<unknown>>): Promise<AttestationForm> => {
    const event = input.event as PatchAttestation;
    const data = formDataToAttestation(event.values, input.context);

    if (input.context.idToEdit) {
      const attestation = input.context.attestations.find(
        (attestation) => attestation.id == input.context.idToEdit
      );

      return await patchData(ATTESTATION_ROUTE_NAME, {
        data: {
          ...attestation,
          formInstance: {
            ...attestation?.formInstance,
            formData: data.formInstance.formData,
            updatedAt: new Date().toISOString(),
          },
        },
      });
    }

    return await patchData(ATTESTATION_ROUTE_NAME, {
      data: data,
    });
  },
  delete: async ({ input }: Input<DeleteAttestation>) =>
    await deleteData(ATTESTATION_ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    }),
};
